<template>
  <section class="home-container">
    <!-- <section class="home-header"></section> -->
    <section class="home-content">
      <router-link to="/gallery">
        <img class="logo" src="../../public/images/logo.svg" alt="eto Logo" />
      </router-link>
    </section>
    <section class="testimonials">
      <Carousel />
    </section>
    <section class="video-showcase">
      <div class="section-header">
        <h2>See Us in Action</h2>
      </div>
      <div class="videos-container">
        <div class="video-item">
          <video controls preload="metadata" poster="../../public/eto_img/eto-trailer3.jpeg" playsinline webkit-playsinline muted="muted" crossorigin="anonymous">
            <source src="../../public/eto_img/eto_vids/ETO.mp4" type="video/mp4; codecs='avc1.42E01E, mp4a.40.2'" />
            <source src="../../public/eto_img/eto_vids/ETO.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div class="video-info">
            <h3>Earth to Oven Experience</h3>
            <p>Discover the passion behind our food</p>
          </div>
        </div>
        <div class="video-item">
          <video controls preload="metadata" poster="../../public/eto_img/IMG_71.jpg" playsinline webkit-playsinline muted="muted" crossorigin="anonymous">
            <source src="../../public/eto_img/eto_vids/AlfieVideo2.mp4" type="video/mp4; codecs='avc1.42E01E, mp4a.40.2'" />
            <source src="../../public/eto_img/eto_vids/AlfieVideo2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div class="video-info">
            <h3>Behind the Scenes</h3>
            <p>Meet Alfie and see our process</p>
          </div>
        </div>
      </div>
      <div class="socials">
        <a href="https://www.instagram.com/earth_to_oven/?hl=en" target="_blank" aria-label="instagram">click here for more photos and updates</a>
      </div>
    </section>
    <section class="content-img">
      <div class="block-one">
        <router-link to="/gallery" class="image-link">
          <img src="../../public/eto_img/IMG_32.jpeg" alt="eto canapés servered at a customers wedding" />
        </router-link>
        <div class="inner-one">
          <router-link to="/gallery" class="image-link">
            <img src="../../public/eto_img/IMG_4.jpeg" alt="an eto flatbread" />
          </router-link>
          <router-link to="/gallery" class="image-link">
            <img src="../../public/eto_img/IMG_53.jpeg" alt="eto canapés servered at a customers wedding" />
          </router-link>
        </div>
      </div>
      <div class="block-two">
        <router-link to="/gallery" class="image-link">
          <img src="../../public/eto_img/IMG_58.jpg" alt="Alfie and joey working in the eto trailer" class="portrait" />
        </router-link>
        <div class="inner-two">
          <router-link to="/gallery" class="image-link">
            <img src="../../public/eto_img/IMG_63.jpeg" alt="Eto wooden sign" />
          </router-link>
          <img src="../../public/images/awards.svg" alt="British Street food award 2022" class="award" />
        </div>
        <router-link to="/gallery" class="image-link">
          <img src="../../public/eto_img/IMG_60.jpg" alt="dish of delicious eto food" class="portrait-addition" />
        </router-link>
      </div>
      <div class="block-three">
        <router-link to="/gallery" class="image-link">
          <img src="../../public/eto_img/IMG_29.jpeg" alt="eto's decadent brownie" />
        </router-link>
        <router-link to="/gallery" class="image-link">
          <img src="../../public/eto_img/IMG_64.jpeg" alt="canapés served at an eto event" />
        </router-link>
      </div>
    </section>
  </section>
</template>

<script>
import Carousel from "../components/Carousel.vue";
export default {
  components: {
    Carousel,
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss">
.home-container {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items: center;

  .home-header {
    display: flex;
    // padding: 5rem;
  }

  .testimonials {
    padding: 2rem;
  }

  .video-showcase {
    padding: 3rem 2rem;
    background: var(--background-fade);

    .socials {
      display: flex;
      justify-content: center;
      text-align: center;
      align-items: center;
      width: 100%;

      a {
        text-decoration: none;
        color: var(--tertiary-colour);
        background-color: var(--background-colour);
        font-size: 1rem;
        border-left: 2px solid var(--tertiary-colour);
        box-shadow: var(--box-shadow);
        margin-top: 3rem;
        padding: 0.5rem;
        border-radius: 0.5rem;
      }
      &:active {
        transform: scale(0.98);
      }
    }

    .section-header {
      text-align: center;
      margin-bottom: 3rem;

      h2 {
        font-size: 2.5rem;
        color: var(--text-colour);
        margin-bottom: 1rem;
        font-weight: 700;
      }

      p {
        color: #718096;
        font-size: 1.1rem;
        font-family: "Avenir";
        margin: 0;
      }
    }

    .videos-container {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
      gap: 2.5rem;
      max-width: 1100px;
      margin: 0 auto;

      .video-item {
        background: white;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        video {
          width: 100%;
          height: 80vh;
          display: block;
          border-radius: 16px 16px 0 0;
          background: var(--background-fade);
          object-fit: cover;

          // Mac Safari specific fixes
          -webkit-transform: translateZ(0);
          transform: translateZ(0);
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          -webkit-perspective: 1000;
          perspective: 1000;

          &::-webkit-media-controls {
            display: flex !important;
          }

          &::-webkit-media-controls-panel {
            display: flex !important;
          }
        }

        .video-info {
          padding: 1.5rem;
          cursor: pointer;

          h3 {
            font-size: 1.25rem;
            color: var(--text-colour);
            margin-bottom: 0.5rem;
            font-weight: 600;
          }

          p {
            color: #718096;
            font-size: 0.95rem;
            line-height: 1.5;
            margin: 0;
            font-family: "Avenir";
          }
        }
      }
    }
  }

  .home-content {
    display: flex;
    height: 90vh;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    background-image: url(../../public/eto_img/IMG_2.jpg);
    background-color: rgba(255, 255, 255, 0.5);
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    background-position: center;
    background-size: cover;
    background-position: 50% 45%;
    img {
      box-shadow: none;
    }
  }

  .content-img {
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--background-colour);
    min-height: 45vh;
    padding: 0.5rem;
    overflow: hidden;

    .image-link {
      display: inline-block;
      text-decoration: none;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 1rem;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 1;
      }

      &::after {
        content: "View Gallery";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 1rem;
        font-weight: 600;
        text-align: center;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 2;
        pointer-events: none;
      }

      // Mobile gallery indicator
      .gallery-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 4px 8px;
        border-radius: 12px;
        font-size: 0.8rem;
        z-index: 3;
        display: none;
      }

      &:hover::before,
      &:hover::after {
        opacity: 1;
      }
    }
    .block-one {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 40vh;
      img {
        width: 22rem;
        max-height: 10rem;
        object-fit: cover;
        margin: 1rem;
        border-radius: 5px;
        transition: all 500ms ease-in-out;
        &:hover {
          scale: 1.1;
        }
      }
      .inner-one {
        display: flex;
        flex-direction: row;
        img {
          max-height: 10rem;
          width: 10rem;
          object-fit: cover;
          transition: all 500ms ease-in-out;
          &:hover {
            scale: 1.1;
          }
        }
      }
    }
    .block-two {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      min-height: 40vh;
      img {
        width: 22rem;
        height: 22rem;
        object-fit: cover;
        margin: 1rem;
        border-radius: 5px;
        transition: all 500ms ease-in-out;
        &:hover {
          scale: 1.1;
        }
      }
      .inner-two {
        display: flex;
        flex-direction: column;
        .award {
          box-shadow: none;
        }
        img {
          max-height: 10rem;
          width: 10rem;
          object-fit: cover;
          transition: all 500ms ease-in-out;
          &:hover {
            scale: 1.1;
          }
        }
      }
    }
    .block-three {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 30vh;
      img {
        width: 20rem;
        height: 10rem;
        object-fit: cover;
        object-position: 50% 20%;
        margin: 1rem;
        border-radius: 5px;
        transition: all 500ms ease-in-out;
        &:hover {
          scale: 1.1;
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .home-container {
    .home-content {
      img {
        width: 20rem;
        height: 20rem;
      }
    }
    .testimonials {
      padding: 0.5rem;
    }
    .video-showcase {
      padding: 2rem 1rem;

      .section-header {
        margin-bottom: 2rem;

        h2 {
          font-size: 2rem;
        }

        p {
          font-size: 1rem;
          padding: 0 1rem;
        }
      }

      .videos-container {
        grid-template-columns: 1fr;
        gap: 2rem;

        .video-item {
          margin: 0 0.5rem;

          .video-info {
            padding: 1rem;

            h3 {
              font-size: 1.1rem;
            }

            p {
              font-size: 0.9rem;
            }
          }
        }
      }
    }
    .content-img {
      .image-link {
        &::after {
          opacity: 1;
          background: rgba(0, 0, 0, 0.7);
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.5rem;
          top: 20px;
          right: 20px;
          left: auto;
          transform: none;
          content: "view gallery";
        }
      }
      min-width: 10vw;
      .block-one {
        display: none;
      }
      .block-two {
        .portrait {
          display: none;
        }
        .portrait-addition {
          width: 10rem;
        }
      }
      .block-three {
        display: none;
      }
    }
  }
}
</style>
